import type { WhitespaceGridRow } from 'hooks/useWhitespaceAnalysisGridData';

import { buildPackArchitectureGlobalFiltersSummary } from 'components/pages/PackArchitecture/packArchitectureGlobalFilters.helpers';

export { getWhitespaceEntryPoint } from 'utils/mixpanelEntryPoint';

export const WHITESPACE_CELL_HOVER_TRACK_MIN_MS = 3000;

export const buildWhitespaceCellId = (xAxisValue: string, yAxis: string, yAxisBucket: string) => `${xAxisValue || '-'}_${yAxis}_${yAxisBucket || '-'}`;
export const getWhitespaceToggleState = (showWhitespaces: boolean) => (showWhitespaces ? 'ON' : 'OFF');
export const getWhitespaceScrollDepthPct = (loaded: number, total: number) => total > 0 ? Math.round((loaded / total) * 100) : 100;
export const getWhitespaceExportDataScope = (scope: string) => scope === 'all_filtered_cells' ? 'all' : 'current';

export const computeWhitespaceGridMetrics = (gridRows: WhitespaceGridRow[], columnHeaders: string[]) => {
    let visibleCellCount = 0;
    let opportunityCellCount = 0;

    gridRows.forEach((row) => {
        columnHeaders.forEach((columnHeader) => {
            const cell = row.cells[columnHeader];
            if (!cell) return;
            visibleCellCount += 1;
            if (cell.isWhitespace) {
                opportunityCellCount += 1;
            }
        });
    });

    return {
        total_cell_count: gridRows.length * columnHeaders.length,
        visible_cell_count: visibleCellCount,
        opportunity_cell_count: opportunityCellCount,
    };
};

export const buildWhitespaceGlobalFiltersApplied = ({
    timeSelectionLabel,
    timePeriodList,
    allCheckedAttribute,
}: {
    timeSelectionLabel?: string;
    timePeriodList?: Array<{ timePeriod?: string; startTimestamp?: number; endTimestamp?: number }>;
    allCheckedAttribute?: Record<string, Record<string, unknown>>;
}) =>
    buildPackArchitectureGlobalFiltersSummary({
        timeSelectionLabel,
        timePeriodList,
        allCheckedAttribute,
    }) || '-';

export const getWhitespaceCellHoverProps = ({
    xAxis,
    yAxis,
    xAxisValue,
    yAxisValue,
    axisBucketValue,
    crossSection,
    crossSectionValue,
    hoverDurationMs,
}: {
    xAxis: string;
    yAxis: string;
    xAxisValue: string;
    yAxisValue: string;
    axisBucketValue: string;
    crossSection: string;
    crossSectionValue: string;
    hoverDurationMs?: number;
}) => ({
    x_axis: xAxis,
    x_axis_value: xAxisValue,
    y_axis: yAxis,
    y_axis_value: yAxisValue,
    axis_bucket_value: axisBucketValue,
    cross_section: crossSection,
    cross_section_value: crossSectionValue,
    ...(hoverDurationMs !== undefined ? { hover_duration: hoverDurationMs } : {}),
});

export const estimateWhitespaceExportFileSizeMb = (payload: unknown) => {
    const bytes = new Blob([typeof payload === 'string' ? payload : JSON.stringify(payload)]).size;
    return Number((bytes / (1024 * 1024)).toFixed(4));
};
